import ConveniadoService from '@src/services/conveniado';

const conveniadoMixin = {
  data() {
    return {
      conveniadoFields: [
        {
          key: 'loja',
          label: 'Conveniado',
          class: 'size-col-20',
          field: 'loja'
        },
        {
          key: 'nome',
          label: 'Nome',
          class: 'size-col-20',
          field: 'nome',
        },
        {
          key: 'especialidade.descricao',
          label: 'Especialidade',
          class: 'size-col-20',
          field: 'especialidade.descricao',
        },
        {
          key: 'grupo.grupo',
          label: 'Grupo',
          class: 'size-col-20',
          field: 'grupo.grupo',
        },
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
    }
  },
  methods: {
    async uploadFile(image, fileName,id){
      return await ConveniadoService.uploadFile(image, fileName, id)
    },
    loadConveniados(grupo=null,ocultarTabela=null) {
      return ConveniadoService
        .list(grupo,null, null, null,ocultarTabela)
        .then(response => response.data)
        .catch(error => error)
    },
    loadConveniadosBySelect(){
      return ConveniadoService
        .listBySelect()
        .then(response => response.data)
        .catch(error => error)
    },
    loadConveniadosFilter(grupo=null, page=null, limit=null, filter=null, ocultarTabela=null) {
      return ConveniadoService
        .list(grupo, page, limit, filter, ocultarTabela)
        .then(response => response)
        .catch(error => error)
    },
    loadConveniadosTeste(grupo=null, page=null, limit=null, filter=null, statusConveniado=null) {
      return ConveniadoService
        .list(grupo, page, limit, filter, null,statusConveniado)
        .then(response => response)
        .catch(error => error)
    },
    findOneConveniado(id, ocultarTabela = null){
      return ConveniadoService.findOne(id, ocultarTabela)
    },
    async registerConveniado(conveniado) {
      await ConveniadoService.create(conveniado)
    },
    async deleteConveniado(id) {
      await ConveniadoService.remove(id)
    },
    async editConveniado(id, conveniado) {
      await ConveniadoService.update(id, conveniado)
    },
    async editTabelaPreco(id, tabelaPreco) {
      await ConveniadoService.updateTabelaPreco(id, tabelaPreco)
    },
    async orcamento(grupo, plano=null) {
      return await ConveniadoService.orcamento(grupo, plano)
    },
    async searchByName(nome, page, limit) {
      return await ConveniadoService.searchByName(nome, page, limit)
    },
    async importTabelaPreco(file, body) {
      return await ConveniadoService.importTabelaPreco(file, body)
    },
    async findOneTabela(id, procedimento = null, allProcedimentos = null) {
      return await ConveniadoService.findOneTabela(id, procedimento, allProcedimentos)
    },
    async searchProcedimentoInTabelaByName(id, procedimento) {
      return await ConveniadoService.searchProcedimentoInTabelaByName(id, procedimento);
    }
    
  }
}

export default conveniadoMixin;
